define('models/customer_chain',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                name: ''
            };
        }
    });
});
